import 'css/style.css'
import App from 'js/App'

new App();
